import React from 'react';
import { Text } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import PropTypes from 'prop-types';
import styles from '../../style/rulesEngine';

const RuleValidationSummary = ({ errors }) => {
  const errorList = Object.values(errors);
  if (errorList.length === 0) return null;

  return (
    <LinearGradient
      colors={['#CC0000', '#7D0000']}
      start={{ x: 0, y: 0 }}
      end={{ x: 0, y: 1 }}
      style={styles.validationSummary}
    >
      <Text style={styles.validationSummaryTitle}>
        This rule has {errorList.length} incomplete field(s)
      </Text>
      {errorList.map((msg, i) => (
        <Text key={i} style={styles.validationSummaryText}>- {msg}</Text>
      ))}
    </LinearGradient>
  );
};

RuleValidationSummary.propTypes = {
  errors: PropTypes.object,
};

export default RuleValidationSummary;
